<template>
  <div v-if='show' class='modal'>
    <div class='box'>
      <div class='icon_close_btn iconic_close iconfont' @click='closeVideo'></div>
      <video id='video' :style='{width: videoWidth, height: videoHeight}' controls='controls' :poster='poster' :src='videoUrl'></video>
    </div>
  </div>
</template>

<script>
import { mediaDevice } from 'utils'

export default {
  props: ['show', 'videoUrl', 'poster'],
  data () {
    return {
      videoWidth: '',
      videoHeight: '',
    }
  },
  methods: {
    closeVideo () {
      const ele = document.getElementById('video')
      ele.pause()
      this.$emit('close')
    },
  },
  mounted () {
    if (mediaDevice() === 'mobile') {
      let width = window.screen.width - 38
      this.videoWidth = width + 'px'
      this.videoHeight = width * 9 / 16 + 'px'
    } else if (mediaDevice() === 'pc') {
      this.videoWidth = 800 + 'px'
      this.videoHeight = 450 + 'px'
    } else {
      this.videoWidth = 680 + 'px'
      this.videoHeight = 383 + 'px'
    }
  },
}
</script>
<style lang='less' scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
video {
  width: 800px;
  height: 450px;
}
.icon_close_btn {
  top: -16px;
  right: -16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 100%;
}
.box {
  position: relative;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  video {
    width: 680px;
    height: 383px;
  }
}
</style>
